// Central GST gate for the whole admin app.
//
// The company has a global "GST Applicable" switch (set in Manage Package).
// When it is OFF, NO GST is charged anywhere — room booking, addon, cover
// charge, package, and the printed bill. Every GST calculation should run its
// slab through `gstPercent(...)` (or check `isGstApplicable()`), so a single
// toggle controls the entire app.

export const isGstApplicable = () => {
  try {
    const c = JSON.parse(sessionStorage.getItem('companyDetails'));
    // Default TRUE when the flag is absent (older sessions / not yet fetched),
    // so we never accidentally drop GST for companies that still charge it.
    return c?.gstApplicable !== false;
  } catch {
    return true;
  }
};

// GST percent for a given amount, honouring the company switch.
// OFF                → 0
// ON  + amount<7875  → 5
// ON  + amount>=7875 → 18
export const gstPercent = (amount) => {
  if (!isGstApplicable()) return 0;
  return Number(amount) < 7875 ? 5 : 18;
};
